import { FC, useEffect } from "react";
import { AutomaticModalHeader } from "./AutomaticModalHeader";
import { AutomaticModalBody } from "./AutomaticModalBody";
import ModalWrapper from "../../../../components/ModalWrapper";

interface Props {
  isOpenModal: boolean;
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AutomaticModal: FC<Props> = ({ isOpenModal, setIsOpenModal }) => {
  useEffect(() => {
    document.body.classList.add("modal-open");
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  return (
    <>
      <ModalWrapper isOpenModal={isOpenModal}>
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered mw-600px w-100 ">
          {/* begin::Modal content */}
          <div className="modal-content">
            <AutomaticModalHeader setIsOpenModal={setIsOpenModal} title={'Изменить сумму автовывода'} />
            {/* begin::Modal body */}
            <div className="mx-5 mx-xl-10 my-2 px-lg-5">
              <AutomaticModalBody setIsOpenModal={setIsOpenModal} />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </ModalWrapper>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};
